import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
     openDialogClient,
     setOrder,
     onUpdateColumn
} from '../../../store/movilidad/reportedeincidencias/actions';
import { sort_by} from '../../../helpers/commons'

import { FieldSet, Table } from '@sigeco/tools';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column'
    }, 
    tableWrap: {
        flex: '1 1 auto'
    }
}));

const ReporteDeIncidenciasList = ({onMapOpen}) => {
    const classes = useStyles();
    const columns = useSelector(state => state.reportedeincidencias.table.columns);
    const loading = useSelector(state => state.reportedeincidencias.loading);
    const order = useSelector(state => state.reportedeincidencias.table.order);
    const orderBy = useSelector(state => state.reportedeincidencias.table.orderBy);
    const store = useSelector(state => state.reportedeincidencias.store);
    const dispatch = useDispatch();

    
    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        dispatch(setOrder(isAsc ? 'desc' : 'asc', property));
        let homes = store.data;
        homes.sort(sort_by(property, isAsc, homes[0][property]));
    };

    const handleResizeColumn = (column) => {
        dispatch(onUpdateColumn(column))
    }
    const onHandleClick = (item) => {
        dispatch(openDialogClient(item));
    }

      

    return ( 
        
        <div className={classes.root}>
        <FieldSet className={classes.root} iconCls="fas fa-th-list" title="Resultados"   >
            <div className={classes.tableWrap} >
                <Table                      
                    columns={columns}
                    count={store.total}
                    loading={loading}
                    onRowClick={()=> {}}
                    onRowDoubleClick={() => {}}
                    onSort={datakey => handleRequestSort(datakey)}
                    onUpdateColumn={handleResizeColumn}
                    rowCount={store.data.length}
                    rowGetter={index => store.data[index]}
                    selected={store.selected}
                    sortBy={orderBy}
                    sortDirection={order}
                    actions={[
                        {
                            iconCls: 'fas fa-file-download',
                            tooltip: 'Imagen de Indencia',
                            onClick: onHandleClick
                        }
                    ]}
                />
            </div>
        </FieldSet>        
       </div>
    )
};

export default ReporteDeIncidenciasList;